import { UliActivityType } from '../../../../../../common/constants';
import { AddressModel } from '../../../../../../common/models';
import { LocalDate } from '../../../../../models';

export class UliDetailsPreviewModel {
  carrierExtId: string;
  carrierName: string;
  carrierNumber: string;
  compartmentAddress: AddressModel;
  customsGoods: boolean;
  dangerousGoods: boolean;
  loadNumber: string;
  origin: string;
  plannedDate: LocalDate;
  region: string;
  slotId: number;
  timeSlot: AllocationViewUliDetailsTimeSlotRangeModel;
  type: UliActivityType;
  uli: string;
  uliStatus: string;
  addressToViews: AllocationViewUliDetailsAddressToViews[];
}

export class AllocationViewUliDetailsTimeSlotRangeModel {
  start: LocalDate;
  end: LocalDate;
}

export class AllocationViewUliDetailsAddressToViews {
  address: AddressModel;
  tos: AllocationViewUliDetailsTOS[];
}

export class AllocationViewUliDetailsTOS {
  huNumber: number;
  plannedDate: LocalDate;
  toNumber: string;
}

export class UliDetailsPreviewCriteria {
  compartmentId: number;
  type: UliActivityType;
  uli: string;
}

export class UliDetailsPreviewStateModel {
  data?: UliDetailsPreviewModel;
  loaded: boolean;
}
